import Params from "../config/Params";

export async function simpleGetCall(url) {
  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function simplePostCall(url, requestBody, params= null) {
 // Utility check if params is empty, null, or undefined
  const isEmptyObject = (obj) => {
    return !obj || typeof obj !== "object" || Object.keys(obj).length === 0;
  };

  // If params not provided or invalid, fallback to Params
  const finalParams = isEmptyObject(params) ? Params : params;

  // Optional: Debugging
  console.log("Using Params:", isEmptyObject(params), finalParams);
  return await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
       customer_id : JSON.parse(localStorage.getItem("CUSTOMER_ID")),
      api_key : JSON.parse(localStorage.getItem("API_KEY")),
      //  customer_id : finalParams.customer_id,
      // api_key : finalParams.api_key
      //'Access-Control-Allow-Credentials': "*"
    },
    withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
  //.then(data=>data.json());
}

export async function simplePostCall2(url, requestBody, params = null) {

  return await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      customer_id: !params ? Params.customer_id : params.customer_id,
      api_key: !params.api_key ?  Params.api_key : params.api_key,
     
      //'Access-Control-Allow-Credentials': "*"
    },
    withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
  //.then(data=>data.json());
}

export async function multipartPostCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      customer_id: Params.customer_id,
      api_key: Params.api_key,
      //'Content-Type': 'multipart/form-data',
      // 'Authorization': 'Token ' + await AsyncStorage.getItem(AppStrings.TOKEN)
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function getWithAuthCall(url) {
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      customer_id: Params.customer_id,
      api_key: Params.api_key,
      //Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.TOKEN)),
    },
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}
export async function simpleGetwithHeadersAndParams(
  url,
  requestBody,
  headers,
  params,
) {
  console.log("URL: ", url, "\nHeaders: ", headers, "\nreq: ", requestBody);
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join("&");

  const fetchUrl = url + (queryString ? `?${queryString}` : "");

  return await fetch(fetchUrl, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      customer_id: Params.customer_id,
      api_key: Params.api_key,
      ...headers,
    },
    body: requestBody,
  }).then((response) => response.json());
}

export async function postWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      customer_id: Params.customer_id,
      api_key: Params.api_key,
      //Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.TOKEN)),
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function putWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      customer_id: Params.customer_id,
      api_key: Params.api_key,
      //Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.TOKEN)),
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function postMultipartWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      // ✅ Don’t set Content-Type manually
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      customer_id: Params.customer_id,
      api_key: Params.api_key,
    },
    body: requestBody, // Must be FormData
  })
    .then((response) => response.text())
    .then((result) => getResult(result))
    .catch((error) => {
      console.error("Upload error:", error);
    });
}


export async function putMultipartWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      customer_id: Params.customer_id,
      api_key: Params.api_key,
      //Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.TOKEN)),
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}
export async function updateProfile(url, requestBody) {
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      customer_id: Params.customer_id,
      api_key: Params.api_key,
      // Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.token)),
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}


export async function downloadBlob(url, body, name = "file") {

  return await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      customer_id: Params.customer_id,
      api_key: Params.api_key,
    },
    body: body
  })
    .then((res) => res.blob()) // ✅ read as blob (file)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = name + ".xlsx"; // or .csv / .pdf
      document.body.appendChild(a);
      a.click();
      a.remove();

    })
    .catch((err) => console.error("Download failed:", err));

}


//-------------------------------------
export async function getResult(data) {
  //console.log('--------------', data);
  return JSON.parse(data.trim());
}
//-------------------------------------
